import { useCallback, useEffect, useState } from 'react';

function useLocationHash() {
  const [hash, setHash] = useState(() => window.location.hash);

  useEffect(() => {
    const hashChangeHandler = () => {
      setHash(window.location.hash);
    };

    window.addEventListener('hashchange', hashChangeHandler);
    return () => {
      window.removeEventListener('hashchange', hashChangeHandler);
    };
  }, []);

  const updateHash = useCallback(
    (newHash) => {
      if (newHash !== hash) window.location.hash = newHash;
    },
    [hash]
  );

  return [hash, updateHash];
}

export default useLocationHash;
